import { Manifest } from '../configuration/Manifest';

export function getDocumentRoots(): Array<HTMLElement> | undefined {
    let roots = [];
    roots = roots.concat(
        Array.from(
            document.querySelectorAll(
                `[data-ksys-app-template-id="${Manifest.ksysAppTemplateId}"]`
            )
        )
    );
    const oldFundCenterID = document.getElementById('fundCenter');
    if (oldFundCenterID) {
        roots.push(oldFundCenterID);
    }
    const oldDocLibraryId = document.getElementById('kurtosysDocLibrary');
    if (oldDocLibraryId) {
        roots.push(oldDocLibraryId);
    }
    return roots as Array<HTMLElement>;
}



// WEBPACK FOOTER //
// ./src/utils/getDocumentRoots.ts